import { render, staticRenderFns } from "./organizarLogin.vue?vue&type=template&id=58de309a&scoped=true"
import script from "./organizarLogin.vue?vue&type=script&lang=js"
export * from "./organizarLogin.vue?vue&type=script&lang=js"
import style0 from "./organizarLogin.vue?vue&type=style&index=0&id=58de309a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58de309a",
  null
  
)

export default component.exports